export enum ReplacementType {
    MERGED = 1,
    LINKED = 2
}

export const ReplacementType_LABELs = {
    [ReplacementType.MERGED] : 'Merged Replacement',
    [ReplacementType.LINKED] : 'Linked Replacement'
}